import { ChangeEvent, FC } from 'react';
import { useController } from 'react-hook-form';

const ControllerElementWrapper: FC<any> = (props: any) => {
  const {
    component: FormComponent,
    control,
    name,
    defaultValue,
    rules,
    handleOnKeyDown,
    handleChange,
    handleBlur,
  } = props;

  const {
    field: { onChange, onBlur, value },
    fieldState: { isTouched, error },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  const { component, ...otherProps } = props;

  return (
    <FormComponent
      value={value}
      {...otherProps}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        handleChange && handleChange(e);
        onChange(e);
      }}
      onBlur={(e: ChangeEvent<HTMLInputElement>) => {
        handleBlur && handleBlur(e);
        onBlur();
      }}
      onKeyDown={handleOnKeyDown}
      error={(isTouched && error && Object.keys(error).length) ? true : false}
    />
  );
};

export default ControllerElementWrapper;
